/** @param {AbortSignal | undefined} signal */
export function createStreamTimerRegistry(signal) {
  const timeoutIds = new Set()
  const intervalIds = new Set()

  const clearTimers = () => {
    for (const id of timeoutIds) clearTimeout(id)
    for (const id of intervalIds) clearInterval(id)
    timeoutIds.clear()
    intervalIds.clear()
  }

  const onAbort = () => {
    signal?.removeEventListener('abort', onAbort)
    clearTimers()
  }

  if (signal) signal.addEventListener('abort', onAbort)

  const dispose = () => {
    signal?.removeEventListener('abort', onAbort)
    clearTimers()
  }

  const addTimeout = (fn, ms) => {
    const id = setTimeout(() => {
      timeoutIds.delete(id)
      if (signal?.aborted) return
      fn()
    }, ms)
    timeoutIds.add(id)
    return id
  }

  const addInterval = (fn, ms) => {
    const id = setInterval(() => {
      if (signal?.aborted) {
        clearInterval(id)
        intervalIds.delete(id)
        return
      }
      fn()
    }, ms)
    intervalIds.add(id)
    return id
  }

  return { addTimeout, addInterval, dispose }
}
